import React from 'react';
import FsgoItems from './FsgoItems';
import FsgoVideosService from '../FsgoVideosService';
import { settings } from '../constants';

class Fsgo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDataFetched: false
        };
    }

    componentWillMount(){
        performance.mark(`fsgo[${this.props.componentId}]-componentWillMount`);
    }

    componentDidUpdate(){
        performance.mark(`fsgo[${this.props.componentId}]-componentDidUpdate`);
    }

    componentDidMount() {
        performance.mark(`fsgo[${this.props.componentId}]-componentDidMount`);
        performance.mark(`fsgo[${this.props.componentId}]-getVideos`);

        FsgoVideosService.getVideos(this.props).then(videos => {
            performance.mark(`fsgo[${this.props.componentId}]-setState`);
            this.setState(() => ({
                isDataFetched: true,
                allLiveVideosCount: videos.allLiveVideosCount,
                liveVideos: videos.liveVideos,
                featureVideos: videos.featureVideos,
                liveMatchVideos: videos.liveMatchVideos,
                featuredMatchVideos: videos.featuredMatchVideos,
                regionNames: videos.regionNames
            }))
        })
    }

    getContainerClass() {
        if (this.props.title || this.props.isFifaWC) {
            return '';
        }

        if (FsgoVideosService.isViewAllSeparatorShown(this.state.regionNames, true)) {
            return 'align-videos';
        }

        return 'align-title';
    }

    render() {
        if (!this.state.isDataFetched) return null;

        const isFifaWCShown = this.props.isFifaWC && (this.state.liveVideos.length > 0 || this.state.featureVideos.length > 0);
        const isFifaWCMatchesShown = this.props.isFifaWC && this.props.isSE && (this.state.liveMatchVideos.length > 0 || this.state.featuredMatchVideos.length > 0);

        return (
            <div className={this.getContainerClass()}>
                {this.props.title && !this.props.isFifaWC &&
                <div className="fsgo-title-container">
                    <h3 className="sidebar-component-title">{this.props.title}</h3>
                    <span className="separator"></span>
                </div>
                }

                <div className="fs-go-sidebar-container">
                    <ul className="tune-in-list">
                        {isFifaWCMatchesShown &&
                            <FsgoItems items={this.state.liveMatchVideos}
                                       state="live"
                                       title={'MATCHES'}
                                       isPost={this.props.postType !== settings.SF_POST_TYPE}
                                       postType={this.props.postType}
                                       isFifaWC={this.props.isFifaWC}
                                       isSE={this.props.isSE}
                                       isMatches={true}
                                       regionNames={this.state.regionNames}/>
                        }
                        {isFifaWCMatchesShown && this.state.featuredMatchVideos.length > 0 &&
                            <FsgoItems items={this.state.featuredMatchVideos}
                                       state="featured"
                                       title={''}
                                       isPost={this.props.postType !== settings.SF_POST_TYPE}
                                       postType={this.props.postType}
                                       isFifaWC={this.props.isFifaWC}
                                       isSE={this.props.isSE}
                                       regionNames={this.state.regionNames}/>
                        }
                        {(this.state.liveVideos.length > 0 || isFifaWCShown) &&
                            <FsgoItems items={this.state.liveVideos}
                                       state="live"
                                       title={this.props.isFifaWC ? (this.props.isSE ? 'TUNE IN' : 'TV COVERAGE'): 'LIVE NOW'}
                                       isPost={this.props.postType !== settings.SF_POST_TYPE}
                                       postType={this.props.postType}
                                       isFifaWC={this.props.isFifaWC}
                                       isFifaWCMatchesShown={isFifaWCMatchesShown}
                                       isSE={this.props.isSE}
                                       regionNames={this.state.regionNames}
                                       allCount={this.state.allLiveVideosCount}/>
                        }
                        {this.state.featureVideos.length > 0 &&
                            <FsgoItems items={this.state.featureVideos}
                                       state="featured"
                                       title={this.props.isFifaWC ? '': 'FEATURED'}
                                       isPost={this.props.postType !== settings.SF_POST_TYPE}
                                       postType={this.props.postType}
                                       isFifaWC={this.props.isFifaWC}
                                       regionNames={this.state.regionNames}/>
                        }
                    </ul>
                </div>
            </div>
        );
    }
}

export default Fsgo;


// WEBPACK FOOTER //
// ./react-app-src/fsgo/components/FsgoComponent.js